export default {
  setUnits(state, data) {
    state.units = data;
  },

  setUnitCode(state, data) {
    state.unitCode = data;
  },

  setWareCategories(state, data) {
    state.wareCategories = data;
  },

  setWareCategoryCode(state, data) {
    state.wareCategoryCode = data;
  },

  setWares(state, data) {
    state.wares = data;
  },
  setWare(state, data) {
    state.ware = data;
  },

  setWareCode(state, data) {
    state.wareCode = data;
  },

  setCommodityCategories(state, data) {
    state.commodityCategories = data;
  },

  setCommodityCategoryCode(state, data) {
    state.commodityCategoryCode = data;
  },

  setCommodities(state, data) {
    state.commodities = data;
  },
  setCommoditiesTotalCount(state, data) {
    state.commoditiesTotalCount = data;
  },
  setCommodity(state, data) {
    state.commodity = data;
  },

  setCommodityCode(state, data) {
    state.commodityCode = data;
  },

  setCommodityInfo(state, data) {
    state.commodityInfo = data;
  },

  setCommodityNavigation(state, data) {
    state.commodityNavigation = data;
  },

  setCommodityBySearch(state, data) {
    state.commodityBySearch = data;
  },

  setShelfs(state, data) {
    state.shelfs = data;
  },

  setShelfCode(state, data) {
    state.shelfCode = data;
  },

  setUnitCoefficients(state, data) {
    state.unitCoefficients = data;
  },

  setCommodityBarcodes(state, data) {
    state.commodityBarcodes = data;
  },

  setCommodityUnitCounts(state, data) {
    state.commodityUnitCounts = data;
  },

  setCommodityImages(state, data) {
    state.commodityImages = data;
  },

  setCommodityAttachments(state, data) {
    state.commodityAttachments = data;
  },
  setCommodityAttachment(state, data) {
    state.commodityAttachment = data;
  },

  setCommodityFeatures(state, data) {
    state.commodityFeatures = data;
  },

  setCommodityFeatureCode(state, data) {
    state.commodityFeatureCode = data;
  },

  setWareVoucherTypes(state, data) {
    state.wareVoucherTypes = data;
  },
  setWareVoucherType(state, data) {
    state.wareVoucherType = data;
  },

  setWareVoucherTypeCode(state, data) {
    state.wareVoucherTypeCode = data;
  },

  setAdditionalCommodityParameters(state, data) {
    state.additionalCommodityParameters = data;
  },

  setParameterValues(state, data) {
    state.parameterValues = data;
  },

  setTempReceipts(state, data) {
    state.tempReceipts = data;
  },
  setTempReceipt(state, data) {
    state.tempReceipt = data;
  },
  setTempReceiptId(state, data) {
    state.tempReceiptId = data;
  },

  setTempReceiptCreateResult(state, data) {
    state.tempReceiptCreateResult = data;
  },

  setTempReceiptCode(state, data) {
    state.tempReceiptCode = data;
  },

  setTempReceiptSerial(state, data) {
    state.tempReceiptSerial = data;
  },

  setTempReceiptNavigation(state, data) {
    state.tempReceiptNavigation = data;
  },

  setTempReceiptCartable(state, data) {
    state.tempReceiptCartable = data;
  },

  setTempReceiptExitCartable(state, data) {
    state.tempReceiptExitCartable = data;
  },

  setReceipts(state, data) {
    state.receipts = data;
  },
  setReceipt(state, data) {
    state.receipt = data;
  },

  setReceiptCode(state, data) {
    state.receiptCode = data;
  },

  setReceiptSerial(state, data) {
    state.receiptSerial = data;
  },

  setReceiptNavigation(state, data) {
    state.receiptNavigation = data;
  },

  setReceiptCheckDelete(state, data) {
    state.receiptCheckDelete = data;
  },

  setReceiptCheckUpdate(state, data) {
    state.receiptCheckUpdate = data;
  },

  setReceiptVoucher(state, data) {
    state.receiptVoucher = data;
  },

  setReceiptAttachments(state, data) {
    state.receiptAttachments = data;
  },

  setReadBuyRequestByCode(state, data) {
    state.readBuyRequestByCode = data;
  },

  setReadBuyRequestByCommodity(state, data) {
    state.readBuyRequestByCommodity = data;
  },

  setReceiptByBarcode(state, data) {
    state.receiptByBarcode = data;
  },

  setReceiptId(state, data) {
    state.receiptId = data;
  },

  setReceiptCreateResult(state, data) {
    state.receiptCreateResult = data;
  },

  setReceiptManagementCartable(state, data) {
    state.receiptManagementCartable = data;
  },

  setDrafts(state, data) {
    state.drafts = data;
  },
  setDraft(state, data) {
    state.draft = data;
  },
  setDraftId(state, data) {
    state.draftId = data;
  },

  setDraftCreateResult(state, data) {
    state.draftCreateResult = data;
  },

  setDraftCode(state, data) {
    state.draftCode = data;
  },

  setDraftSerial(state, data) {
    state.draftSerial = data;
  },

  setDraftNavigation(state, data) {
    state.draftNavigation = data;
  },

  setDraftCheckCreate(state, data) {
    state.draftCheckCreate = data;
  },

  setDraftCheckUpdate(state, data) {
    state.draftCheckUpdate = data;
  },

  setDraftVoucher(state, data) {
    state.draftVoucher = data;
  },

  setReadDraftRequestByCode(state, data) {
    state.readDraftRequestByCode = data;
  },

  setDraftAttachments(state, data) {
    state.draftAttachments = data;
  },

  setDraftRequests(state, data) {
    state.draftRequests = data;
  },
  setDraftRequest(state, data) {
    state.draftRequest = data;
  },
  setDraftRequestId(state, data) {
    state.draftRequestId = data;
  },

  setDraftRequestCreateResult(state, data) {
    state.draftRequestCreateResult = data;
  },

  setDraftRequestCode(state, data) {
    state.draftRequestCode = data;
  },

  setDraftRequestSerial(state, data) {
    state.draftRequestSerial = data;
  },

  setDraftRequestNavigation(state, data) {
    state.draftRequestNavigation = data;
  },

  setDraftRequestCartable(state, data) {
    state.draftRequestCartable = data;
  },

  setDraftRequestCheckCreate(state, data) {
    state.draftRequestCheckCreate = data;
  },

  setDraftRequestCheckUpdate(state, data) {
    state.draftRequestCheckUpdate = data;
  },

  setDraftManagementCartable(state, data) {
    state.draftManagementCartable = data;
  },

  setReceiptCartable(state, data) {
    state.receiptCartable = data;
  },

  setDraftCartable(state, data) {
    state.draftCartable = data;
  },

  setNumeralCirculation(state, data) {
    state.numeralCirculation = data;
  },
  setRialCirculation(state, data) {
    state.rialCirculation = data;
  },

  setNumeralCardex(state, data) {
    state.numeralCardex = data;
  },
  setRialCardex(state, data) {
    state.rialCardex = data;
  },
  setCirculationCommodity(state, data) {
    state.circulationCommodity = data;
  },

  setReceiptConfirmCartable(state, data) {
    state.receiptConfirmCartable = data;
  },

  setReceiptUnConfirmCartable(state, data) {
    state.receiptUnConfirmCartable = data;
  },

  setDraftConfirmCartable(state, data) {
    state.draftConfirmCartable = data;
  },

  setDraftValue(state, data) {
    state.draftValue = data;
  },

  setDraftUnConfirmCartable(state, data) {
    state.draftUnConfirmCartable = data;
  },

  setInventoryDeduction(state, data) {
    state.inventoryDeduction = data;
  },

  setInventorySummary(state, data) {
    state.inventorySummary = data;
  },
  setInventorySummaryDetail(state, data) {
    state.inventorySummaryDetail = data;
  },

  setCommoditySleep(state, data) {
    state.commoditySleep = data;
  },

  setCommodityCirculation(state, data) {
    state.commodityCirculation = data;
  },

  setNegativeCommodity(state, data) {
    state.negativeCommodity = data;
  },

  setSortReceipt(state, data) {
    state.sortReceipt = data;
  },

  setTransferCommodities(state, data) {
    state.transferCommodities = data;
  },
  setTransferCommodity(state, data) {
    state.transferCommodity = data;
  },

  setTransferCommodityCode(state, data) {
    state.transferCommodityCode = data;
  },

  setTransferCommodityCartable(state, data) {
    state.transferCommodityCartable = data;
  },

  setWareDocument(state, data) {
    state.wareDocument = data;
  },
  setWareFinancialDocument(state, data) {
    state.wareFinancialDocument = data;
  },

  setNumeralInventory(state, data) {
    state.numeralInventory = data;
  },
  setRialInventory(state, data) {
    state.rialInventory = data;
  },

  setWarehousings(state, data) {
    state.warehousings = data;
  },
  setWarehousing(state, data) {
    state.warehousing = data;
  },

  setWarehousingId(state, data) {
    state.warehousingId = data;
  },

  setWarehousingCreateResult(state, data) {
    state.warehousingCreateResult = data;
  },

  setWarehousingCommodities(state, data) {
    state.warehousingCommodities = data;
  },

  setWarehousingContradictions(state, data) {
    state.warehousingContradictions = data;
  },

  setWarehousingTag(state, data) {
    state.warehousingTag = data;
  },

  setWarehousingCommodityByWare(state, data) {
    state.warehousingCommodityByWare = data;
  },

  setWarehousingCommodityBatches(state, data) {
    state.warehousingCommodityBatches = data;
  },

  setCommodityBatches(state, data) {
    state.commodityBatches = data;
  },

  setUserLimitWares(state, data) {
    state.userLimitWares = data;
  },

  setReqBuys(state, data) {
    state.reqBuys = data;
  },
  setReqBuy(state, data) {
    state.reqBuy = data;
  },
  setReqBuyId(state, data) {
    state.reqBuyId = data;
  },

  setReqBuyCreateResult(state, data) {
    state.reqBuyCreateResult = data;
  },

  setReqBuyCode(state, data) {
    state.reqBuyCode = data;
  },

  setReqBuyNavigation(state, data) {
    state.reqBuyNavigation = data;
  },

  setNotYetBuyers(state, data) {
    state.notYetBuyers = data;
  },

  setReqBuyCartable(state, data) {
    state.reqBuyCartable = data;
  },

  setPackageTypes(state, data) {
    state.packageTypes = data;
  },

  setPackageTypeCode(state, data) {
    state.packageTypeCode = data;
  },

  setBoms(state, data) {
    state.boms = data;
  },
  setBom(state, data) {
    state.bom = data;
  },

  setBomCode(state, data) {
    state.bomCode = data;
  },

  setBomCommodities(state, data) {
    state.bomCommodities = data;
  },

  setCommodityInventoryWare(state, data) {
    state.commodityInventoryWare = data;
  },

  setReceiptNotes(state, data) {
    state.receiptNotes = [...data];
  },
  setDraftsNotes(state, data) {
    state.draftsNotes = [...data];
  },

  setBuyTypes(state, data) {
    state.buyTypes = data;
  },
  setBuyTypeCode(state, data) {
    state.buyTypeCode = data;
  },

  setReceiptVerificationCartable(state, data) {
    state.receiptVerificationCartable = data;
  },
  setDraftVerificationCartable(state, data) {
    state.draftVerificationCartable = data;
  },

  setSettings(state, data) {
    state.settings = data;
  },

  setCartableLog(state, data) {
    state.cartableLog = data;
  },

  setPrintLink(state, data) {
    state.printLink = data;
  },

  setCommodityGroupConfigs(state, data) {
    state.commodityGroupConfigs = data;
  },

  setServices(state, data) {
    state.services = data;
  },
  setService(state, data) {
    state.service = data;
  },
  setServiceSerial(state, data) {
    state.serviceSerial = data;
  },

  setServiceGroups(state, data) {
    state.serviceGroups = data;
  },
  setServiceGroupCode(state, data) {
    state.serviceGroupCode = data;
  },
};
